<template>
    <v-dialog v-model="dialog" max-width="800" transition="dialog-bottom-transition" @keydown.enter="cancel" @keydown.esc="cancel">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark :disabled="loading" @click="cancel">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-toolbar-title>Last {{ groupedHistory.length }} Picks - {{ location }}</v-toolbar-title>
            </v-toolbar>
            <v-layout column>
                <v-data-table :headers="headers" :items="groupedHistory" hide-actions :loading="loading">                            
                    <template v-slot:items="{ item }">
                        <td>{{ item.PickDate | formatDate }}</td>
                        <td><span style="white-space: pre-line">{{ teamFormat(item) }}&nbsp;</span></td>
                        <td v-if="uom == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID"><span style="white-space: pre-line" v-html="derivedKgsFormat(item)"></span></td>
                        <td v-if="uom == $Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID"><span style="white-space: pre-line" v-html="derivedTraysFormat(item)"></span></td>    
                        <td v-if="uom == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID"><span style="white-space: pre-line" v-html="derivedKgsPerHourFormat(item)"></span></td>
                        <td v-if="uom == $Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID"><span style="white-space: pre-line" v-html="derivedPunnetsPerHourFormat(item)"></span></td>
                        <td v-if="uom == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID"><span style="white-space: pre-line" v-html="secondsPerKgFormat(item)"></span></td>
                        <td v-if="uom == $Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID"><span style="white-space: pre-line" v-html="secondsPerPunnetFormat(item)"></span></td>
                        <td v-if="uom == $Constants.HARVESTPLAN_UOM_ENUM.KG.ID"><span style="white-space: pre-line" v-html="isBurrosUsedFormat(item)"></span></td>
                        <td v-if="uom == $Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID"><span style="white-space: pre-line" v-html="isBurrosUsedFormat(item)"></span></td>
                    </template>
                </v-data-table>               
            </v-layout>
            <v-card-actions class="pt-4">
                <v-spacer></v-spacer>                             
                <v-btn @click="cancel" :disabled="loading" color="primary">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

import UtilService from '@/services/utilService.js';
import harvestPlanApi from '@/api/harvestPlanApi';

export default {
    props: {
        location: {
            required: true,
            type: String
        },
        cropLocationID: {
            required: true,
            type: Number
        },
        varietyID: {
            required: true,
            type: Number
        },
        uom: {
            required: false,
            type: String
        }
    },
    data() {
        return {
            dialog: true,
            loading: false,
            pickHistory: []            
        }
    },
    watch: {
        dialog(val) {
            if (!val) {
                this.cancel();
            }
        }
    },
    computed: {
        headers() {
            if(this.uom == this.$Constants.HARVESTPLAN_UOM_ENUM.TRAYSPUNNETS.ID) {
                return [
                {
                    text: "Pick Date",
                    value: "PickDate",
                    sortable: true
                },
                {
                    text: "Team",
                    value: "Team",
                    sortable: true
                },              
                {
                    text: "Derived Trays",
                    value: "DerivedTrays",
                    sortable: true
                },                
                {
                    text: "Derived Pun/Hr",
                    value: "DerivedPunnetsPerHour",
                    sortable: true
                },
                {
                    text: "Seconds %",
                    value: "SecondsPerPunnet",
                    sortable: true
                },
                {
                    text: "Burros Used(Y/N)",
                    value: "IsBurrosUsed",
                    sortable: true
                }
                ] 
            } else {
                return [
                {
                    text: "Pick Date",
                    value: "PickDate",
                    sortable: true
                },
                {
                    text: "Team",
                    value: "Team",
                    sortable: true
                },
                {
                    text: "Derived Kgs",
                    value: "DerivedKgs",
                    sortable: true
                },              
                {
                    text: "Derived Kgs/Hr",
                    value: "DerivedKgsPerHour",
                    sortable: true
                },
                {
                    text: "Seconds %",
                    value: "SecondsPerKg",
                    sortable: true
                },
                {
                    text: "Burros Used(Y/N)",
                    value: "IsBurrosUsed",
                    sortable: true
                }
                ] 
            }
        },
        groupedHistory() {
            let group = [];
            for (const pick of this.pickHistory) {
                // round derivedKgs
                pick.DerivedKgs = Math.round(pick.DerivedKgs);
                let match = group.find(g => g.PickDate == pick.PickDate);
                if (!match) {
                    group.push(pick);
                } else {
                    match.TotalTeams = (match.TotalTeams || 1) + 1;
                    match.TotalDerivedKgs = (match.TotalDerivedKgs || match.DerivedKgs) + pick.DerivedKgs;
                    match.TotalDerivedPunnets = (match.TotalDerivedPunnets || match.DerivedPunnets) + pick.DerivedPunnets;
                    match.TotalSecondsKg = (match.TotalSecondsKg || match.SecondsKg) + pick.SecondsKg;
                    match.TotalSecondsPunnet = (match.TotalSecondsPunnet || match.SecondsPunnet) + pick.SecondsPunnet;
                    match.TotalDerivedTrays = (match.TotalDerivedTrays || match.DerivedTrays) + pick.DerivedTrays;
                    match.TotalDerivedKgsPerHour = (match.TotalDerivedKgsPerHour || match.DerivedKgsPerHour) + pick.DerivedKgsPerHour;
                    match.TotalDerivedPunnetsPerHour = (match.TotalDerivedPunnetsPerHour || match.DerivedPunnetsPerHour) + pick.DerivedPunnetsPerHour;
                    match.TotalIsBurrosUsed = match.TotalIsBurrosUsed == 'Y' || pick.IsBurrosUsed == 'Y' ? 'Y' : 'N';

                    match.Team += '\n' + pick.Team;
                    match.DerivedKgs += '\n' + pick.DerivedKgs;
                    match.SecondsPerKg += '\n' + pick.SecondsPerKg;
                    match.SecondsPerPunnet += '\n' + pick.SecondsPerPunnet;
                    match.DerivedTrays += '\n' + pick.DerivedTrays;
                    match.DerivedKgsPerHour += '\n' + pick.DerivedKgsPerHour;
                    match.DerivedPunnetsPerHour += '\n' + pick.DerivedPunnetsPerHour;
                    match.IsBurrosUsed += '\n' + pick.IsBurrosUsed;
                }
            }

            return group;
        }
    },
    methods: {
        teamFormat(item) {
            if (item.TotalTeams > 0) {
                return item.Team + '\n';
            } 
            
            return item.Team;            
        },
        derivedKgsFormat(item) {
            if (item.TotalTeams > 0) {
                return `${item.DerivedKgs}<hr/>${item.TotalDerivedKgs}`;
            }

            return item.DerivedKgs;
        },
        derivedTraysFormat(item) {
            if (item.TotalTeams > 0) {
                return `${item.DerivedTrays}<hr/>${item.TotalDerivedTrays}`;
            }

            return item.DerivedTrays;
        },
        derivedKgsPerHourFormat(item) {
            if (item.TotalTeams > 0) {
                return `${item.DerivedKgsPerHour}<hr/>${UtilService.formatNumber(item.TotalDerivedKgsPerHour / item.TotalTeams, 2)}`;
            }

            return item.DerivedKgsPerHour;
        },
        derivedPunnetsPerHourFormat(item) {
            if (item.TotalTeams > 0) {
                return `${item.DerivedPunnetsPerHour}<hr/>${UtilService.formatNumber(item.TotalDerivedPunnetsPerHour / item.TotalTeams, 2)}`;
            }

            return item.DerivedPunnetsPerHour;
        },
        secondsPerKgFormat(item) {
            if (item.TotalTeams > 0) {
                return `${item.SecondsPerKg}<hr/>${item.TotalDerivedKgs == 0 ? 0 : UtilService.formatNumber(item.TotalSecondsKg / item.TotalDerivedKgs * 100, 2)}`;
            }
            return item.SecondsPerKg;
        },
        secondsPerPunnetFormat(item) {
            if (item.TotalTeams > 0) {
                return `${item.SecondsPerPunnet}<hr/>${item.TotalDerivedPunnets == 0 ? 0 : UtilService.formatNumber(item.TotalSecondsPunnet / item.TotalDerivedPunnets * 100, 2)}`;
            }
            return item.SecondsPerPunnet;
        },
        cancel() {
            this.$emit("cancel");
        },
        isBurrosUsedFormat(item) {
            if (item.TotalTeams > 0) {
                return `${item.IsBurrosUsed}<hr/>${item.TotalIsBurrosUsed}`;
            }
            return item.IsBurrosUsed;
        }
    },
    async created() {
        this.loading = true;
        
        this.pickHistory = await harvestPlanApi.getPickHistory(this.cropLocationID, this.varietyID);

        this.loading = false;
    }
}
</script>
